/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Domain,
    DomainFromJSON,
    DomainFromJSONTyped,
    DomainToJSON,
} from './Domain';
import {
    DomainLearningOutcomeTemplate,
    DomainLearningOutcomeTemplateFromJSON,
    DomainLearningOutcomeTemplateFromJSONTyped,
    DomainLearningOutcomeTemplateToJSON,
} from './DomainLearningOutcomeTemplate';
import {
    FundamentalDomain,
    FundamentalDomainFromJSON,
    FundamentalDomainFromJSONTyped,
    FundamentalDomainToJSON,
} from './FundamentalDomain';
import {
    Indicator,
    IndicatorFromJSON,
    IndicatorFromJSONTyped,
    IndicatorToJSON,
} from './Indicator';

/**
 * 
 * @export
 * @interface ScienceBranch
 */
export interface ScienceBranch {
    /**
     * 
     * @type {string}
     * @memberof ScienceBranch
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScienceBranch
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ScienceBranch
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof ScienceBranch
     */
    name?: string | null;
    /**
     * 
     * @type {Array<Domain>}
     * @memberof ScienceBranch
     */
    domains?: Array<Domain> | null;
    /**
     * 
     * @type {Array<Indicator>}
     * @memberof ScienceBranch
     */
    indicators?: Array<Indicator> | null;
    /**
     * 
     * @type {Array<DomainLearningOutcomeTemplate>}
     * @memberof ScienceBranch
     */
    learningOutcomeTemplates?: Array<DomainLearningOutcomeTemplate> | null;
    /**
     * 
     * @type {string}
     * @memberof ScienceBranch
     */
    fundamentalDomainId?: string;
    /**
     * 
     * @type {FundamentalDomain}
     * @memberof ScienceBranch
     */
    fundamentalDomain?: FundamentalDomain;
}

export function ScienceBranchFromJSON(json: any): ScienceBranch {
    return ScienceBranchFromJSONTyped(json, false);
}

export function ScienceBranchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScienceBranch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'domains': !exists(json, 'domains') ? undefined : (json['domains'] === null ? null : (json['domains'] as Array<any>).map(DomainFromJSON)),
        'indicators': !exists(json, 'indicators') ? undefined : (json['indicators'] === null ? null : (json['indicators'] as Array<any>).map(IndicatorFromJSON)),
        'learningOutcomeTemplates': !exists(json, 'learningOutcomeTemplates') ? undefined : (json['learningOutcomeTemplates'] === null ? null : (json['learningOutcomeTemplates'] as Array<any>).map(DomainLearningOutcomeTemplateFromJSON)),
        'fundamentalDomainId': !exists(json, 'fundamentalDomainId') ? undefined : json['fundamentalDomainId'],
        'fundamentalDomain': !exists(json, 'fundamentalDomain') ? undefined : FundamentalDomainFromJSON(json['fundamentalDomain']),
    };
}

export function ScienceBranchToJSON(value?: ScienceBranch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'name': value.name,
        'domains': value.domains === undefined ? undefined : (value.domains === null ? null : (value.domains as Array<any>).map(DomainToJSON)),
        'indicators': value.indicators === undefined ? undefined : (value.indicators === null ? null : (value.indicators as Array<any>).map(IndicatorToJSON)),
        'learningOutcomeTemplates': value.learningOutcomeTemplates === undefined ? undefined : (value.learningOutcomeTemplates === null ? null : (value.learningOutcomeTemplates as Array<any>).map(DomainLearningOutcomeTemplateToJSON)),
        'fundamentalDomainId': value.fundamentalDomainId,
        'fundamentalDomain': FundamentalDomainToJSON(value.fundamentalDomain),
    };
}

